module.exports = __webpack_public_path__ + "static/media/flyboxwhite2.f0a8f33e.png";